import { render, staticRenderFns } from "./FaceControl.vue?vue&type=template&id=d89b0a18"
import script from "./FaceControl.vue?vue&type=script&lang=js"
export * from "./FaceControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports